import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=3f4e166a&scoped=true&"
import script from "./SideCart.vue?vue&type=script&lang=js&"
export * from "./SideCart.vue?vue&type=script&lang=js&"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=3f4e166a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e166a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\redeem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4e166a')) {
      api.createRecord('3f4e166a', component.options)
    } else {
      api.reload('3f4e166a', component.options)
    }
    module.hot.accept("./SideCart.vue?vue&type=template&id=3f4e166a&scoped=true&", function () {
      api.rerender('3f4e166a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Redeem/components/SideCart.vue"
export default component.exports